module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "name": _vm.name,
      "type": _vm.inputType
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11e21ab5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./public_html/scripts/vue-components/datetime-picker.vue
// module id = 19
// module chunks = 0